export default "/images/paylater.png?5d044b84ce9c9fd692ab5b7622e20f5a";